// extracted by mini-css-extract-plugin
export default {"about":"AboutSection_about__6mWyc","description":"AboutSection_description__o9kNw","title":"AboutSection_title__nZLqT","image":"AboutSection_image__jnTfP"};